import { Component, OnInit } from '@angular/core';
import { Permission } from '../../models/permission.model';
import { AppService } from '../../app.service';

@Component({
  selector: 'fx-ib-mam',
  templateUrl: './ib-mam.component.html',
  styleUrls: ['./ib-mam.component.sass'],
})
export class IbMamComponent implements OnInit {
  permission: Permission;
  tabs = [
    {
      label: 'MAM Master',
    }
  ];
  tabSelect: any;
  constructor(private appService: AppService) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
    this.tabSelect = this.tabs[0];
  }
  onChangeTab(event): void {
    this.tabSelect = event;
  }
}
